import { Modal as DefaultModal } from '@getinapp/appetizer';
import styled, { css } from 'styled-components';

export const Modal = styled(DefaultModal)`
  background: white;
  padding: 0;
  margin: 0;
  filter: drop-shadow(0px 4px 12px rgba(20, 20, 20, 0.2));

  > div:first-of-type {
    display: none;
  }

  button {
    ${({ theme }) => css`
      color: ${theme.colors.white};
    `}
  }
`;
